export default __webpack_public_path__ + "static/media/cerec_third.cf4a896a.jpg";